// extracted by mini-css-extract-plugin
export default {"button":"smallDateButton_button__cHesE","placeholder":"smallDateButton_placeholder__TmUJ0"};